import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link, useParams, useNavigate } from 'react-router-dom';

export default function CustomerDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Customer #{id}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Customer detail view.
      </Typography>
      <Button component={Link} to="/app/customers" onClick={() => navigate('/app/customers')}>
        Back to Customers
      </Button>
    </Box>
  );
}
